import { mapState } from 'vuex'
import objectLength from '@/services/mixins/objectLength'

export default {
	mixins: [
		objectLength
	],
	computed: {
        ...mapState(['userTeam', 'userTeams']),
		currentTeamName () {
			if (this.userTeams.length && this.objectLength(this.userTeam)) {
				const team = this.userTeams.find(item => item.id === this.userTeam.id)
				if (team) {
					return team.name
				}
			}
		}
	}
}
